import {
  AppConfigProvider,
  AppNotificationsProvider,
  AppThemeProvider,
  AuthProvider,
  AxiosInterceptorsProvider,
  DatePickerProvider,
  TradingEtlProvider,
  TranslateProvider,
} from 'contexts';

import { ErrorBoundary } from 'components/error-boundary';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { AppRoutes } from 'router';
import { persistor, store } from 'store';
import 'styles/app.global.scss';
import { LocalizationProvider } from './contexts/localization';

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <ErrorBoundary>
          <AppConfigProvider>
            <AppThemeProvider>
              <AppNotificationsProvider>
                <AxiosInterceptorsProvider>
                  <TranslateProvider>
                    <AuthProvider>
                      <LocalizationProvider>
                        <DatePickerProvider>
                          <DndProvider backend={HTML5Backend}>
                            <TradingEtlProvider>
                              <AppRoutes />
                            </TradingEtlProvider>
                          </DndProvider>
                        </DatePickerProvider>
                      </LocalizationProvider>
                    </AuthProvider>
                  </TranslateProvider>
                </AxiosInterceptorsProvider>
              </AppNotificationsProvider>
            </AppThemeProvider>
          </AppConfigProvider>
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  );
}

export default App;
